<template>
  <div>
  </div>
</template>

<script>

export default {
  name: 'wxAuth',
  data: function () {
    return {
      code: '',
      to: ''
    }
  },
  methods: {
    getUserInfo () {
      let _this = this
      this.axios.get('/webApi/v3/user/userInfo').then(resp => {
        _this.userInfo = resp.data
        localStorage.setItem('userInfo', JSON.stringify(resp.data))
        setTimeout(function () {
          window.location.href = _this.to
        }, 2000)
      })
    }
  },
  components: {

  },
  mounted () {
    let loading = this.$loading({
      lock: true,
      text: '微信登录中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    let _this = this
    this.code = this.$route.query.code
    this.to = this.$route.query.state
    this.axios.get('/webApi/v3/wechat/login?code=' + this.code).then(resp => {
      if (resp.data.type === 'bind') {
        _this.$message({
          message: '微信绑定成功',
          type: 'success'
        })
      }
      if (resp.data.type === 'login') {
        _this.$message({
          message: '微信登录成功',
          type: 'success'
        })
      }
      this.getUserInfo()
      loading.close()
      this.$store.commit('hideLoginDialog');
      //
    }).catch(() => {
      setTimeout(function () {
        window.location.href = _this.to
      }, 3000)
    })
  },
  watch: {

  }
}
</script>

<style  scoped></style>



// WEBPACK FOOTER //
// src/app/wxAuth.vue